module.exports = __webpack_public_path__ + "static/media/tipo-ventas.947411a9.svg";